import { RBTDatosFecha } from "./rbtdatosFecha";

export class RBTCampaign {
    id:string;
    name:string;
    datosFecha: RBTDatosFecha[]=[];
}